import HeroEnhanced from '@/components/landing/HeroEnhanced';

export function FirstRunExperience({ onAddMedication }: { onAddMedication: () => void }) {
  return (
    <div className="w-full -mx-4 sm:-mx-6 lg:-mx-8">
      <HeroEnhanced onAddMedication={onAddMedication} isFirstRun={true} />
    </div>
  );
}
